interface LeaveRange {
    allDay: boolean;
    startDate: string | Date;
    endDate: string | Date;
}

/**
 * Un permiso es de día completo si está marcado como allDay o si su rango
 * cubre la jornada laboral (8:00 - 17:00), p. ej. permisos de varios días
 * creados antes de que "Día completo" aceptara fecha final.
 */
export function isFullDayLeave({ allDay, startDate, endDate }: LeaveRange): boolean {
    if (allDay) return true;

    const start = new Date(startDate);
    const end = new Date(endDate);

    return start.getHours() === 8 && start.getMinutes() === 0
        && end.getHours() === 17 && end.getMinutes() === 0;
}
